<template>
  <div class="md-layout"  v-if="stablishment">
    <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
      

      <div id="menu" class="md-layout-item md-size-100 md-medium-size-100">
        <md-card  :class="getStatus()" >   
          
        

          <div class="linkcontainer" v-if="!defaultOrderId">
              <span class="ml-2 instagram" v-if="stablishment && stablishment.instagram" >
                <a :href="stablishment.instagram" target="_blank">
                  <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 16 16"><path fill="currentColor" d="M8 0C5.829 0 5.556.01 4.703.048C3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7C.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297c.04.852.174 1.433.372 1.942c.205.526.478.972.923 1.417c.444.445.89.719 1.416.923c.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417c.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046c.78.035 1.204.166 1.486.275c.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485c.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598c-.28.11-.704.24-1.485.276c-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598a2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485c-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486c.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276c.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92a.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217a4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334a2.667 2.667 0 0 1 0-5.334"/></svg>
                </a>
              </span>
              <span class="ml-2 website" v-if="stablishment &&  stablishment.website">
                    <a :href="stablishment.website" target="_blank">
                    <svg height="30px" width="30px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 107.366 107.366" xml:space="preserve" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path style="fill:#010002;" d="M107.366,53.683C107.366,24.082,83.283,0,53.683,0c-4.982,0-9.785,0.734-14.366,2.011L39.21,1.94 c-0.025,0.036-0.043,0.075-0.068,0.115C16.595,8.417,0,29.125,0,53.683c0,29.601,24.082,53.683,53.683,53.683 c4.985,0,9.785-0.734,14.366-2.011l0.107,0.075c0.025-0.036,0.047-0.075,0.068-0.115C90.77,98.948,107.366,78.237,107.366,53.683z M5.343,56.292H24.69c0.193,5.766,0.837,11.438,2.004,16.942H9.366C7.047,68.002,5.662,62.29,5.343,56.292z M102.022,51.077H82.679 c-0.197-5.769-0.837-11.442-2.008-16.946H98C100.319,39.364,101.704,45.076,102.022,51.077z M77.468,51.077h-21.18V34.131h19.061 C76.58,39.625,77.264,45.298,77.468,51.077z M56.292,28.924V5.343c2.53,0.136,5.014,0.415,7.43,0.923 c4.502,6.986,7.97,14.595,10.289,22.658H56.292z M51.077,28.924h-18.12c2.137-7.92,5.354-15.436,9.57-22.368 c2.766-0.655,5.622-1.056,8.55-1.213V28.924z M51.077,34.132v16.946H29.84c0.111-5.766,0.712-11.442,1.85-16.946H51.077z M24.633,51.077H5.34c0.319-6.002,1.704-11.717,4.023-16.946h17.046C25.335,39.654,24.741,45.319,24.633,51.077z M29.898,56.292 h21.18v16.942H32.013C30.785,67.74,30.102,62.068,29.898,56.292z M51.077,78.441v23.581c-2.53-0.136-5.018-0.415-7.43-0.923 c-4.502-6.986-7.97-14.595-10.293-22.658C33.355,78.441,51.077,78.441,51.077,78.441z M56.292,78.441h18.116 c-2.14,7.92-5.354,15.432-9.57,22.368c-2.766,0.659-5.622,1.056-8.55,1.213V78.441H56.292z M56.292,73.234V56.292h21.237 c-0.111,5.762-0.712,11.438-1.854,16.942C75.675,73.234,56.292,73.234,56.292,73.234z M82.732,56.292h19.294 c-0.319,6.002-1.704,11.714-4.023,16.942H80.957C82.031,67.712,82.625,62.047,82.732,56.292z M95.28,28.924H79.393 c-1.943-7.147-4.681-13.993-8.235-20.403C81.294,12.454,89.765,19.694,95.28,28.924z M35.219,8.883 c-3.31,6.32-5.848,13.041-7.627,20.038H12.086C17.425,19.991,25.514,12.898,35.219,8.883z M12.086,78.441h15.89 c1.94,7.147,4.678,13.993,8.231,20.403C26.072,94.911,17.601,87.671,12.086,78.441z M72.146,98.483 c3.31-6.32,5.848-13.041,7.627-20.038H95.28C89.94,87.374,81.852,94.467,72.146,98.483z"></path> </g> </g></svg>
                    </a>
              </span>
            </div>
          
          
          <div v-if="stablishment !== undefined && stablishment.coverImage && !defaultOrderId" class="w-100 mb-1 imagebanner">
             <img  :src="stablishment.coverImage" class="w-100 coverimage" />
              <div  class="logorestocontainer">  
              <div class="logoresto" :style="'background:url('+stablishment.logo+')'">
                 
              </div>  
              </div>  
          </div>

          <div class="w-100 mt-3">      
            <avatar v-if="order.user" :logo="order.user.avatar"></avatar>
          </div>

          <md-card-content class="text-center text-white pb-4">
             <div class="md-layout px-2">
              <div class="md-layout-item float-left md-size-100 mb-4 logotitle align-center">
                  <h2 class="titlemenu" >
                        {{order.buyerName}}
                   </h2>
              <h4> {{localDate()}} </h4>
              </div>

            <div class="text-center mb-2 w-100">
                  <span v-if="(profile.access < 0 || profile.access == null) && profile.paymentType == 'month'" class="p-1">
                    <small  class="badge badge-primary text-white">
                      <md-icon class="text-white">meeting_room</md-icon>
                     <md-icon class="text-white">all_inclusive</md-icon> {{$t('unlimitedAccess')}} 
                    </small>
                  </span>
                    <span  v-if="profile.access > 0" class="p-1">
                      <small  class="badge badge-primary text-white">
                        <md-icon class="text-white">self_improvement</md-icon>
                        <span>{{profile.remainingAccess}} {{$t('remainingAccesses')}}</span> 
                      </small>
                    </span>
              </div>

             </div>
            
            <div v-if="order.status == 'done'" >
               <div class="swal2-icon swal2-success " style="display: flex;">
                <div class="swal2-success-circular-line-left" style="background-color: rgb(255, 255, 255);"></div>
                <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>
                <div class="swal2-success-ring"></div> <div class="swal2-success-fix" style="background-color: rgb(255, 255, 255);"></div>
                <div class="swal2-success-circular-line-right" style="background-color: rgb(255, 255, 255);"></div>
              </div>
              <h3> {{ $t('welcome')}} </h3>    
              <h4 v-if="order.paymentDate == null">Aún no tienes una fecha de pago definida, por favor comunicate con nosotros para que terminemos de crear tu perfil</h4>
              <h4 v-else>{{ $t('payment_due', { days: order.daysDifference }) }}</h4>
            </div>

            <div v-if="order.status == 'warning'" >
              <div class="swal2-icon swal2-warning swal2-icon-show" style="display: flex;">
                <div class="swal2-icon-content">!</div>
              </div>
              <h3> {{ $t('welcome')}} </h3>
              <h4> {{$t('payment_overdue', { days: order.daysDifference })}} </h4>
            </div>
            
            <div v-if="order.status == 'cancelled'">
              <div class="swal2-icon swal2-error swal2-icon-show" style="display: flex;"><span class="swal2-x-mark">
                  <span class="swal2-x-mark-line-left"></span>
                  <span class="swal2-x-mark-line-right"></span>
                </span>
              </div>
              

              <h3> {{$t('accessBlocked')}} </h3>
              

              <h4 v-if="profile.remainingAccess == 0"> Ya no te quedan accesos </h4>
              <h4 v-else> {{$t('payment_overdue', { days: order.daysDifference })}} </h4>


            </div>


              <div class="w-100 text-center mt-4" v-if="!isInDashboard">
                 <router-link class="md-button md-white px-4 py-3 border-radius " :to="{ path: '/dashboard' }">  
                      <strong>{{$t('myProfile')}}</strong> 
                   </router-link> 
              </div>
                   <span v-if="!isInDashboard"> redireccionando a tu perfil... {{countdown}}</span>


          </md-card-content>
          

        </md-card>
      </div>

    </div>
     
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { createAccessAction,getAction,getAccessAction } from "@/pages/Orders/actions";
import { getUserAction,getMyProfileAction } from "@/pages/Users/actions";

import { i18n } from '@/i18n';
import { format } from 'date-fns';


import {
  Avatar
} from "@/components";

export default {
  props: {
    defaultOrderId: {
      type: String
    },
    isWebsocket:{
      type: Boolean
    },
    isInDashboard:{
      type: Boolean,
      default: false
    }
  },
  components: {
   Avatar
  },
  data() {
    return {
      welcome:false,
      orderid:false,
      order:false,
      stablishment:false,
      businessConfig: false,
      profile:false,
      countdown:10,
    };
  },
  created() {
    this.orderid = this.$route.params.orderid || this.defaultOrderId;
    this.getOrder();
    if(this.countdown > 0 && !this.isWebsocket && !this.isInDashboard) {
      this.startCountdown();
    }
  },
  methods: {

    localDate() {
      const date = new Date(this.order.createdAt);
        // Formatear la fecha según la configuración regional del navegador
        const savedLanguage = localStorage.getItem('language') || 'en';

        return new Intl.DateTimeFormat(savedLanguage, {
          dateStyle: 'medium', // Puedes cambiar a 'full', 'long', 'medium' o 'short'
          timeStyle: 'short'  // Cambia a 'full', 'long', 'medium' o 'short' según lo que necesites
        }).format(date);
      },  
    isDateOlderThanFiveHours() {
      // Obtener la fecha de creación de la orden
      const date = new Date(this.order.createdAt);
      
      // Obtener la fecha y hora actuales
      const now = new Date();

      // Restar 5 horas a la fecha actual
      const fiveHoursAgo = new Date(now.getTime() - 5 * 60 * 60 * 1000);

      // Comparar la fecha de la orden con la fecha actual menos 5 horas
      return date < fiveHoursAgo
    },
    logout(){
       localStorage.removeItem('identifier');
       localStorage.removeItem('customerName');
       localStorage.removeItem('customerAvatar');
       localStorage.removeItem('userId');
       this.$router.push('/access/'+this.order.qr._id);
    },
    getStatus(){


        if(this.order.status == 'done'){
          return "bg-success"
        }
        if(this.order.status == 'warning'){
          return "bg-success"
        }
        if(this.order.status == 'cancelled'){
          return "bg-danger"
        }
    },
    startCountdown() {
      const interval = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
          console.log(this.countdown)
        } else {
          clearInterval(interval);
          this.$router.push("/dashboard"); // Redirige cuando el contador llegue a 0
        }
      }, 1000); // Disminuye el contador cada segundo
    },
    async getOrder() {
      try {
        const response2 = await getMyProfileAction();
        this.profile = response2;

        const response = await getAccessAction(this.orderid);
        this.order = response.order;
        this.stablishment = this.order.stablishment;

        if (!this.businessConfig.waitingDays) {
          this.businessConfig.waitingDays = 10;
        }

        let daysDifference = this.order.daysDifference || 0;

        if (
          this.order.status === "cancelled" &&
          this.businessConfig.waitingDays - daysDifference > 0 &&
          this.profile.remainingAccess > 0
        ) {
          this.order.status = "warning";
        }

        if (
          this.stablishment.primaryColor === "#FFFFFF" ||
          this.stablishment.primaryColor === "#ffffff" ||
          !this.stablishment.primaryColor
        ) {
          this.stablishment.primaryColor = "#333";
        }

        if (
          this.stablishment.secondaryColor === "#FFFFFF" ||
          this.stablishment.secondaryColor === "#ffffff" ||
          !this.stablishment.secondaryColor
        ) {
          this.stablishment.secondaryColor = "#333";
        }
      } catch (error) {
        this.errorMessage = error.message;
      }
    },
  



  }
};
</script>



<style scoped>
.imagebanner{
      margin-top: -50%;
}

div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line] {
    display: block;
    position: absolute;
    top: 2.6em;
    width: 3.6em;
    height: .3em;
    border-radius: .125em;
    background-color: #f27474;
}
div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=long] {
    top: 2.25em;
    right: .9em;
    width: 2.9375em;
    transform: rotate(-45deg);
}
div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=tip] {
    top: 2.75em;
    left: 1.1em;
    width: 1.5625em;
    transform: rotate(45deg);
}
div:where(.swal2-icon).swal2-success .swal2-success-ring {
    top: -0.75em;
}
.swal2-success-circular-line-left,
.swal2-success-circular-line-right,
.swal2-success-fix{
  background-color: inherit !important;
}
</style>